/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by andrebarata on 2018-08-22.
 */

'use strict';

import { NgModule } from '@angular/core';
import { SearchNavigationDirective } from './directive';

@NgModule({
  imports     : [],
  declarations: [SearchNavigationDirective],
  exports     : [SearchNavigationDirective]
})
export class SearchNavigation {
}
